import { GridView, Person, ManageAccounts, Soap, LocalLibrary, Feed, Map } from '@mui/icons-material';
import { VotingIcon } from 'assets/icons/Icons';
import { MODULE, ROUTES } from 'shared/constants/constant';

const menuItems = {
	[MODULE.DASHBOARD]: {
		label: 'Home',
		url: ROUTES.DASHBOARD,
		icon: <GridView />,
		title: 'Home'
	},
	[MODULE.USER]: {
		label: 'Users',
		url: ROUTES.USER,
		icon: <Person />,
		title: 'Users'
	},
	[MODULE.MASTER]: {
		label: 'Master',
		url: ROUTES.MASTER,
		icon: <ManageAccounts />,
		title: 'Master'
	},
	[MODULE.MAPPING]: {
		label: 'Mapping',
		url: ROUTES.MAPPING,
		icon: <Map />,
		title: 'Mapping'
	},
	[MODULE.MY_SALES]: {
		label: 'My Sales',
		url: ROUTES.MY_SALES,
		icon: <Soap />,
		title: 'My Sales'
	},
	[MODULE.INDUSTRY_SALES]: {
		label: 'Industry Sales',
		url: ROUTES.INDUSTRY_SALES,
		icon: <LocalLibrary />,
		title: 'Industry Sales'
	},
	[MODULE.NEWS_ROOM]: {
		label: 'News Room',
		url: ROUTES.NEWS_ROOM,
		icon: <Feed />,
		title: 'News Room'
	},
	[MODULE.VOTING]: {
		label: 'Poll',
		url: ROUTES.VOTING,
		icon: <VotingIcon width='21px' height='21px' />,
		title: 'Poll'
	}
};

export default menuItems;
